$(function () {
  $('#routeSearch').on('click', function (ev) {
    ev.preventDefault();
    
    const start = $('select[name="station"]').val();
    const goal = $('input[name="goal"]').val();
    
    if (!start) {
      alert('出発地を選択してください');
      return false;
    }
    if (!goal) {
      alert('到着地を入力してください');
      return false;
    }

    // Googleマップ用のURLパラメータ生成
    const e_start = encodeURIComponent(start);
    const e_goal = encodeURIComponent(goal);

    // dirflg=r : 電車・バス（公共交通機関）ルート検索
    const gmapURL = 'https://www.google.com/maps/dir/?api=1&origin=' + e_start + '&destination=' + e_goal + '&travelmode=transit';
    
    window.open(gmapURL, '_blank');
  });
});